import React, { useEffect, useRef } from "react";
import successImg from "./OBJECTS.avif";
import { useNavigate } from "react-router-dom";
const SuccessCard = () => {
  const formRef = useRef(null);
  useEffect(() => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate("/");
    }, 2000);
  });
  return (
    <div
      ref={formRef}
      className="flex items-center justify-center min-h-screen mt-24 mb-24  mx-4"
    >
      <div className="bg-white lg:py-24 lg:px-20  py-20 px-6 shadow-lg text-center border  rounded-[24px]">
        <div className="flex flex-col items-center">
          <img
            src={successImg}
            alt="Success Illustration"
            className="mb-8 w-[500px] "
          />
          <h2 className="text-[40px] font-semibold text-[#37474F]">
            Your response has been recorded.
          </h2>
          <p className="text-[#4D4D4D] mt-2 font-normal text-base">
            Our sales team will reach out to you shortly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessCard;
